import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import colors from '../../assets/theme/colors';
import { getCareSourceDisplayStatus, getCareSourceOriginalText } from './careSourceStatusModel';

const PendingCaptureTimelineSection = ({ sources = [] }) => {
  const navigate = useNavigate();
  if (!sources.length) return null;

  return (
    <Stack spacing={1} sx={{ px: { xs: 1.35, md: 1.65 }, py: 1 }} aria-label="Saved notes being organized">
      {sources.map((source) => {
        const status = getCareSourceDisplayStatus(source);
        return (
          <Box key={source.id} sx={{ p: 1.5, border: `1px solid ${colors.semantic.line}`, borderRadius: 2.5 }}>
            <Typography sx={{ fontSize: '0.8rem', fontWeight: 800 }}>{status.label.startsWith('Saved') ? status.label : `Saved · ${status.label}`}</Typography>
            <Typography sx={{ mt: 0.5, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
              {getCareSourceOriginalText(source) || 'Your original capture is saved.'}
            </Typography>
            <Typography sx={{ mt: 0.5, fontSize: '0.78rem', color: 'text.secondary' }}>{status.detail}</Typography>
            <Button onClick={() => navigate(`/sources/${source.id}`)} sx={{ mt: 0.5, textTransform: 'none' }}>
              View saved capture
            </Button>
          </Box>
        );
      })}
    </Stack>
  );
};

export default PendingCaptureTimelineSection;
